module.exports = __webpack_public_path__ + "static/media/Tv2_Norvegia.856aaabb.png";